import type { ComponentProps } from "react"

export default function MapLayerFilled(
  props: ComponentProps<"svg"> & { fill?: string },
) {
  const { fill = "currentColor", ...svgProps } = props

  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...svgProps}
    >
      <g clipPath="url(#clip0_2790_149)">
        <path
          d="M15.9999 8.52295L8.02295 13.0229L0.0229492 8.52295L1.04295 7.94995L8.02295 11.8759L15.0029 7.94995L15.9999 8.52295ZM1.04295 10.9499L0.0229492 11.5229L7.93795 15.9749C7.99095 16.0049 8.05595 16.0049 8.10895 15.9749L15.9999 11.5229L15.0029 10.9499L8.02295 14.8759L1.04295 10.9499ZM8.02295 1.02295L0.0229492 5.52295L8.02295 10.0229L15.9999 5.52295L8.02295 1.02295Z"
          fill={fill}
        />
      </g>
      <defs>
        <clipPath id="clip0_2790_149">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}
